import { Ycs } from '../types/ycs'

export const getYcs = () => {
    const w = window as unknown as { ycs: Ycs }
    w.ycs = w.ycs || { pageConfig: { exp: {} } }
    return w.ycs
}

const ycsVar: Ycs = getYcs()

export { ycsVar as ycs }
